import React, { useState, useEffect } from "react";
import { Menu, Dropdown, Icon } from "antd";
import { useHistory } from "react-router-dom";
import Tab, { TabItem } from "./RecurringTabs/Tabs";
import editIcon from "../../../../assets/images/budget/dropdown.png";
import filterIcon from "../../../../assets/images/budget/filter.png";
import settingIcon from "../../../../assets/SVGs/setting.svg";
import NewLoader from "../../../../components/styled-components/loader/NewLoader";
import "../AddTransaction/AddTransaction.css";
import { AccountTransaction } from "./RecurringTabs/AccountTransaction";
import DEATH_API from "../../../../apis/death.api";
import swal from "sweetalert";
export const Recurring = () => {
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const onTabSelected = (index) => {
    setSelectedIndex(index);
  };
  const [filter, setFilter] = useState(null);
  const [transactions, setTransactions] = useState(null);
  const [clientTransactions, setClientTransactions] = useState(null);
  const [allTransactions, setAllTransactions] = useState(null);
  const [searchQuery, setSearchQuery] = useState(""); // State for search query
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);

  const getTransactions = async () => {
    try {
      setLoading(true);
      let data = await DEATH_API.getRecurringTransaction();
      if (data && data.data) {
        console.log("data", data.data);
        const allRecurring = data.data;
        // const allRecurring = data.data.map((item) => {
        //   if (item.amount) {
        //     item.amount = -1*(item.amount);
        //   }
        //   return item;
        // });
        setAllTransactions(allRecurring);
        // const allAccount = data.data;

        const allAccount = allRecurring.filter((item) => {
          return item.hidden !== true;
        });
        const checkingSavingData = allRecurring.filter((item) => {
          return (
            (item.accountType === "checking" ||
              item.accountType === "savings") &&
            item.categoryFromPlaid !== null && item.hidden !== true
          );
        });
        const creditData = allRecurring.filter((item) => {
          return (
            item.accountType === "credit card" &&
            item.categoryFromPlaid !== null && item.hidden !== true
          );
        });
        const investmentData = allRecurring.filter((item) => {
          return (
            item.accountType !== "student" &&
            item.accountType !== "mortgage" &&
            item.accountType !== "loan" &&
            item.accountType !== "auto" &&
            item.accountType !== "business" &&
            item.accountType !== "commercial" &&
            item.accountType !== "construction" &&
            item.accountType !== "consumer" &&
            item.accountType !== "overdraft" &&
            item.accountType !== "home equity" &&
            item.accountType !== "line of credit" &&
            item.accountType !== "credit card" &&
            item.accountType !== "savings" &&
            item.accountType !== "checking" &&
            item.categoryFromPlaid !== null && item.hidden !== true
          );
        });
        const studentData = allRecurring.filter((item) => {
          return (
            (item.accountType === "student" ||
              item.accountType === "mortgage" ||
              item.accountType === "loan" ||
              item.accountType === "auto" ||
              item.accountType === "business" ||
              item.accountType === "commercial" ||
              item.accountType === "construction" ||
              item.accountType === "consumer" ||
              item.accountType === "overdraft" ||
              item.accountType === "home equity" ||
              item.accountType === "line of credit") &&
            item.categoryFromPlaid !== null && item.hidden !== true
          );
        });
        const nullCategoryDataNullCategory = allRecurring.filter((item) => {
          return item.categoryFromPlaid === null;
        });
        const hiddenTransactions = allRecurring.filter((item) => {
          return item.hidden === true;
        });
        const resultObject = {
          allAccount,
          checkingSavingData,
          creditData,
          investmentData,
          studentData,
          nullCategoryDataNullCategory,
          hiddenTransactions
        };
        setTransactions(resultObject);
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  const getClientTransactions = async () => {
    try {
      setLoading(true);
      let data = await DEATH_API.getBudgetTransaction();
      if (data && data.data) {
        const allAccountTransactions = data.data;
        // const allAccountTransactions = data.data.map((item) => {
        //   // If amount is negative, convert it to positive
        //   if (item.amount) {
        //     item.amount = -1*(item.amount);
        //   }
        //   return item;
        // });
        setClientTransactions(allAccountTransactions);
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  const handleFilter = async (type) => {
    console.log("type", type);
    setFilter(type);
    let sortedData;
    switch (type) {
      case "category":
        sortedData =
          allTransactions &&
          [...allTransactions].sort((a, b) => {
            if (a.categoryFromPlaid && b.categoryFromPlaid) {
              return a.categoryFromPlaid.localeCompare(b.categoryFromPlaid);
            } else {
              return 0; // No sorting if category name is missing
            }
          });
        break;
      case "Amount": // Corrected to match potential input cases
        sortedData =
          allTransactions &&
          [...allTransactions].sort((a, b) => {
            return a.amount - b.amount;
          });
        break;
      case "Account":
        sortedData =
          allTransactions &&
          [...allTransactions].sort((a, b) => {
            if (a.accountType && b.accountType) {
              return a.accountType.localeCompare(b.accountType);
            } else {
              return 0; // No sorting if account type is missing
            }
          });
        break;
      case "Due Date":
        sortedData =
          allTransactions &&
          [...allTransactions].sort((a, b) => {
            return new Date(a.dueDate) - new Date(b.dueDate);
          });
        break;
      case "Alphabetical": // Sorting alphabetically
        sortedData =
          allTransactions &&
          [...allTransactions].sort((a, b) => {
            if (a.itemName && b.itemName) {
              return a.itemName.localeCompare(b.itemName);
            } else {
              return 0; // No sorting if item name is missing
            }
          });
        break;
      default:
        sortedData = allTransactions && [...allTransactions];
    }
    console.log("sorted Data", sortedData);
    manageSortedData(sortedData);
  };
  const manageSortedData = (data) => {
    // const allAccount = data;
    const allRecurring = data;
    // const allRecurring = data.map((item) => {
    //   if (item.amount) {
    //     item.amount = -1*(item.amount);
    //   }
    //   return item;
    // });
    const allAccount = allRecurring.filter((item) => {
      return item.hidden !== true;
    });
    const checkingSavingData =
    allRecurring &&
    allRecurring.filter((item) => {
        return (
          (item.accountType === "checking" || item.accountType === "savings") &&
          item.categoryFromPlaid !== null && item.hidden !== true
        );
      });
    const creditData =
    allRecurring &&
    allRecurring.filter((item) => {
        return (
          item.accountType === "credit card" && item.categoryFromPlaid !== null && item.hidden !== true
        );
      });
    const investmentData =
    allRecurring &&
    allRecurring.filter((item) => {
        return (
          item.accountType === "mortgage" && item.categoryFromPlaid !== null && item.hidden !== true
        );
      });
    const studentData =
    allRecurring &&
    allRecurring.filter((item) => {
        return (
          item.accountType === "student" && item.categoryFromPlaid !== null && item.hidden !== true
        );
      });
    const nullCategoryDataNullCategory =
    allRecurring &&
    allRecurring.filter((item) => {
        return item.categoryFromPlaid === null && item.hidden !== true;
      });
    const hiddenTransactions =
    allRecurring &&
    allRecurring.filter((item) => {
        return item.hidden === true;
      });
    const resultObject = {
      allAccount,
      checkingSavingData,
      creditData,
      investmentData,
      studentData,
      nullCategoryDataNullCategory,
      hiddenTransactions
    };
    setTransactions(resultObject);
  };

  const filteredTransactions = async () => {
    // const allAccount = allTransactions && allTransactions;
    const allRecurring = allTransactions && allTransactions;
    // const allRecurring = allTransactions && allTransactions.map((item) => {
    //   if (item.amount) {
    //     item.amount = -1*(item.amount);
    //   }
    //   return item;
    // });
    const allAccount = allRecurring && allRecurring.filter((item) => {
      return item.hidden !== true;
    });
    const checkingSavingData =
    allRecurring &&
    allRecurring.filter((item) => {
        return (
          (item.accountType === "checking" || item.accountType === "savings") &&
          item.categoryFromPlaid !== null && item.hidden !== true
        );
      });
    const creditData =
    allRecurring &&
    allRecurring.filter((item) => {
        return (
          item.accountType === "credit card" && item.categoryFromPlaid !== null && item.hidden !== true
        );
      });
    const investmentData =
    allRecurring &&
    allRecurring.filter((item) => {
        return (
          item.accountType === "mortgage" && item.categoryFromPlaid !== null && item.hidden !== true
        );
      });
    const studentData =
    allRecurring &&
    allRecurring.filter((item) => {
        return (
          item.accountType === "student" && item.categoryFromPlaid !== null && item.hidden !== true
        );
      });
    const nullCategoryDataNullCategory =
    allRecurring &&
    allRecurring.filter((item) => {
        return item.categoryFromPlaid === null && item.hidden !== true;
      });
    const hiddenTransactions =
    allRecurring &&
    allRecurring.filter((item) => {
        return item.hidden === true;
      });
    const resultObject = {
      allAccount,
      checkingSavingData,
      creditData,
      investmentData,
      studentData,
      nullCategoryDataNullCategory,
      hiddenTransactions,
    };
    setTransactions(resultObject);
  };

  const deleteRecurringTransaction = async (id) => {
    swal({
      title: "Are you sure?",
      text: "Are you sure you want to delete this Recurring Transaction?",
      dangerMode: true,
      buttons: ["No, cancel it!", "Yes, Delete it!"],
      icon: "warning",
      type: "warning",
      closeOnConfirm: false,
      closeOnCancel: false,
    }).then(async function (isConfirm) {
      // Redirect the user
      if (isConfirm) {
        try {
          setLoading(true);
          let deletedIds = {
            recurringIds: [id],
          };
          await DEATH_API.deleteMultipleRecurringTransaction(deletedIds);
          setLoading(false);
          // if (filter) {
          //   console.log("filter",filter)
          //   await getTransactions();
          //   await handleFilter(filter);
          // } else {
          setFilter(null);
          await getTransactions();
          // }
          // setUpdateState(!updateState);
        } catch (error) {
          console.log(error);
          setLoading(false);
        }
        setTimeout(async () => {
          swal("Deleted!", "Your Transaction has been deleted.", "success");
        }, 0);
      } else {
        swal("Cancelled", "Your Transaction is safe :)", "error");
      }
    });
  };

  const hideRecurringTransaction = async (id) => {
    swal({
      title: "Are you sure?",
      text: "Are you sure you want to Hide this Recurring Transaction?",
      dangerMode: true,
      buttons: ["No, cancel it!", "Yes, Hide it!"],
      icon: "warning",
      type: "warning",
      closeOnConfirm: false,
      closeOnCancel: false,
    }).then(async function (isConfirm) {
      // Redirect the user
      if (isConfirm) {
        try {
          setLoading(true);
          let deletedIds = {
            recurringIds: [id],
            hidden: true,
          };
          await DEATH_API.hideRecurringTransaction(deletedIds);
          setLoading(false);
          setFilter(null);
          await getTransactions();
        } catch (error) {
          console.log(error);
          setLoading(false);
        }
        setTimeout(async () => {
          swal("Hidden!", "Your Transaction has been Hidden.", "success");
        }, 0);
      } else {
        swal("Cancelled", "Your Transaction is safe :)", "error");
      }
    });
  };
  const restoreRecurringTransaction = async (id) => {
    swal({
      title: "Are you sure?",
      text: "Are you sure you want to Restore this Recurring Transaction?",
      dangerMode: true,
      buttons: ["No, cancel it!", "Yes, Restore it!"],
      icon: "warning",
      type: "warning",
      closeOnConfirm: false,
      closeOnCancel: false,
    }).then(async function (isConfirm) {
      // Redirect the user
      if (isConfirm) {
        try {
          setLoading(true);
          let deletedIds = {
            recurringIds: [id],
            hidden:false,
          };
          await DEATH_API.hideRecurringTransaction(deletedIds);
          setLoading(false);
          setFilter(null);
          await getTransactions();
        } catch (error) {
          console.log(error);
          setLoading(false);
        }
        setTimeout(async () => {
          swal("Restored!", "Your Transaction has been Restored.", "success");
        }, 0);
      } else {
        swal("Cancelled", "Your Transaction is safe :)", "error");
      }
    });
  };
  useEffect(() => {
    getAll();
  }, []);
  const getAll = async () => {
    await getClientTransactions();
    await getTransactions();
  };

  const searchData = (transactions, query) => {
    const lowercaseQuery = query.toLowerCase();
    let arrayToSearch = [];
    let tabIndex = selectedIndex;
    // Determine which array to search based on the tab index from state
    switch (tabIndex) {
      case 0: // All Accounts
        arrayToSearch = transactions.allAccount;
        break;
      case 1: // Checking/Saving
        arrayToSearch = transactions.checkingSavingData;
        break;
      case 2: // Credit Data
        arrayToSearch = transactions.creditData;
        break;
      // case 3: // Investments
      //   arrayToSearch = transactions.investmentData;
      //   break;
      // case 4: // Student Data
      //   arrayToSearch = transactions.studentData;
      // case 3: // uncategorized Data
      //   arrayToSearch = transactions.nullCategoryDataNullCategory;
      //   break;
      case 3: // uncategorized Data
        arrayToSearch = transactions.hiddenTransactions;
        break;
      default:
        break;
    }
    // Perform the search
    return arrayToSearch.filter((item) => {
      const description = item.description
        ? item.description.toLowerCase()
        : "";
      const notes = item.notes ? item.notes.toLowerCase() : "";
      const itemName = item.itemName ? item.itemName.toLowerCase() : "";
      const categoryFromPlaid = item.categoryFromPlaid
        ? item.categoryFromPlaid.toLowerCase()
        : "";
      const subCategory = item.subCategory
        ? item.subCategory.toLowerCase()
        : "";
      const amountString = item.amount
        ? item.amount.toString().toLowerCase()
        : "";
      // const dateString = item.date ? item.date.toLowerCase() : '';
      const dateString = item.date
        ? new Date(item.date)
            .toLocaleDateString("en-US", {
              year: "numeric",
              month: "2-digit",
              day: "2-digit",
            })
            .replace(/\//g, "-")
        : "";
      return (
        description.includes(lowercaseQuery) ||
        notes.includes(lowercaseQuery) ||
        itemName.includes(lowercaseQuery) ||
        categoryFromPlaid.includes(lowercaseQuery) ||
        subCategory.includes(lowercaseQuery) ||
        amountString.includes(lowercaseQuery) || // Search in amount
        dateString.includes(lowercaseQuery) // Search in date
      );
    });
  };
  const filteredData =
    transactions && transactions ? searchData(transactions, searchQuery) : [];
    
  const selectedRowsDataKeys = (data) => {
    setSelectedRowKeys(data);
  };
  const deleteSelectedTransaction = async () => {
    const isMultiple = selectedRowKeys && selectedRowKeys.length > 1;
    const textMessage = isMultiple
      ? "Are you sure you want to delete these transactions?"
      : "Are you sure you want to delete this transaction?";

    const successMessage = isMultiple
      ? "Your transactions have been deleted."
      : "Your transaction has been deleted.";

    const cancelMessage = isMultiple
      ? "Your Transactions are safe :)"
      : "Your Transaction is safe :)";

    swal({
      title: "Are you sure?",
      text: textMessage,
      dangerMode: true,
      buttons: ["No, cancel it!", "Yes, Delete it!"],
      icon: "warning",
      type: "warning",
      closeOnConfirm: false,
      closeOnCancel: false,
    }).then(async function (isConfirm) {
      // Redirect the user
      if (isConfirm) {
        try {
          setLoading(true);
          let deleteIds = {
            recurringIds: selectedRowKeys,
          };
          await DEATH_API.deleteMultipleRecurringTransaction(deleteIds);
          setSelectedRowKeys([]);
          setLoading(false);
          setFilter(null);
          await getTransactions();
        } catch (error) {
          console.log(error);
          setLoading(false);
        }
        setTimeout(async () => {
          swal("Deleted!", successMessage, "success");
        }, 0);
      } else {
        swal("Cancelled", cancelMessage, "error");
      }
    });
  };
  const hideSelectedTransaction = async () => {
    const isMultiple = selectedRowKeys && selectedRowKeys.length > 1;
    const textMessage = isMultiple
      ? "Are you sure you want to Hide these transactions?"
      : "Are you sure you want to Hide this transaction?";

    const successMessage = isMultiple
      ? "Your transactions have been Hidden."
      : "Your transaction has been Hidden.";

    const cancelMessage = isMultiple
      ? "Your Transactions are safe :)"
      : "Your Transaction is safe :)";

    swal({
      title: "Are you sure?",
      text: textMessage,
      dangerMode: true,
      buttons: ["No, cancel it!", "Yes, Hide it!"],
      icon: "warning",
      type: "warning",
      closeOnConfirm: false,
      closeOnCancel: false,
    }).then(async function (isConfirm) {
      // Redirect the user
      if (isConfirm) {
        try {
          setLoading(true);
          let deleteIds = {
            recurringIds: selectedRowKeys,
            hidden:true,
          };
          await DEATH_API.hideRecurringTransaction(deleteIds);
          setSelectedRowKeys([]);
          setLoading(false);
          setFilter(null);
          await getTransactions();
        } catch (error) {
          console.log(error);
          setLoading(false);
        }
        setTimeout(async () => {
          swal("Hidden!", successMessage, "success");
        }, 0);
      } else {
        swal("Cancelled", cancelMessage, "error");
      }
    });
  };
  const restoreSelectedTransaction = async () => {
    const isMultiple = selectedRowKeys && selectedRowKeys.length > 1;
    const textMessage = isMultiple
      ? "Are you sure you want to Restore these transactions?"
      : "Are you sure you want to Restore this transaction?";

    const successMessage = isMultiple
      ? "Your transactions have been Restored."
      : "Your transaction has been Restored.";

    const cancelMessage = isMultiple
      ? "Your Transactions are safe :)"
      : "Your Transaction is safe :)";

    swal({
      title: "Are you sure?",
      text: textMessage,
      dangerMode: true,
      buttons: ["No, cancel it!", "Yes, Restore it!"],
      icon: "warning",
      type: "warning",
      closeOnConfirm: false,
      closeOnCancel: false,
    }).then(async function (isConfirm) {
      // Redirect the user
      if (isConfirm) {
        try {
          setLoading(true);
          let deleteIds = {
            recurringIds: selectedRowKeys,
            hidden:false,
          };
          await DEATH_API.hideRecurringTransaction(deleteIds);
          setSelectedRowKeys([]);
          setLoading(false);
          setFilter(null);
          await getTransactions();
        } catch (error) {
          console.log(error);
          setLoading(false);
        }
        setTimeout(async () => {
          swal("Restored!", successMessage, "success");
        }, 0);
      } else {
        swal("Cancelled", cancelMessage, "error");
      }
    });
  };
  // const handleDeleteEditModal = async () => {
  //   try {
  //     setLoading(true);
  //     const userToken = localStorage.getItem("userLoginToken");
  //     const baseUrl = "https://sam.assetplanet.com/budget-service";
  //     const response = await axios.put(
  //       `${baseUrl}/delete/transactions`,
  //       { transactionIds: selectedRowKeys && selectedRowKeys },
  //       {
  //         headers: {
  //           Authorization: `Bearer ${userToken}`,
  //         },
  //       }
  //     );
  //     console.log("response", response);
  //     if (response && response.data && response.data.status === 200) {
  //       swal("Success", response.data.message, "success");
  //       const cmIds = transactions && transactions.allAccount && selectedRowKeys
  //       ? transactions.allAccount
  //           .filter(item => selectedRowKeys.includes(item.id))
  //           .map(item => item.hasOwnProperty('cmId') ? item.cmId : null)
  //           .filter(cmId => cmId !== undefined && cmId !== null)
  //       : [];
  //       console.log("cmIds",cmIds)
  //     }
  //     await getRecurringTransaction();
  //     setLoading(false);
  //   } catch (error) {
  //     setLoading(false);
  //     if (error && error.data && error.data.message) {
  //       swal("Success", error.data.message, "success");
  //     }
  //     console.error("Error fetching user data:", error);
  //   }
  //   setSelectedRowKeys([]);
  // };
  const Tabs = [
    {
      id: 1,
      name: "All Accounts",
      component: (
        <AccountTransaction
          // transactions={{ allAccount: TableData ? TableData :[] }}
          // transactions={transactions && transactions.allAccount}
          transactions={filteredData && filteredData}
          clientTransactions={clientTransactions && clientTransactions}
          deleteTransaction={deleteRecurringTransaction}
          selectedRowsDataKeys={selectedRowsDataKeys}
          selectedRowKeys={selectedRowKeys}
          hideRecurringTransaction={hideRecurringTransaction}
          restoreRecurringTransaction={restoreRecurringTransaction}
          tabName="All Accounts"
        />
      ),
    },
    {
      id: 2,
      name: "Checking and Saving",
      component: (
        <AccountTransaction
          // transactions={transactions && transactions.checkingSavingData}
          transactions={filteredData && filteredData}
          clientTransactions={clientTransactions && clientTransactions}
          deleteTransaction={deleteRecurringTransaction}
          selectedRowsDataKeys={selectedRowsDataKeys}
          selectedRowKeys={selectedRowKeys}
          hideRecurringTransaction={hideRecurringTransaction}
          restoreRecurringTransaction={restoreRecurringTransaction}
          tabName="Checking and Saving"
        />
      ),
    },
    // {
    //   id: 3,
    //   name: "Loans",
    //   component: (
    //     <AccountTransaction
    //       transactions={transactions && transactions.studentData}
    //       clientTransactions={clientTransactions && clientTransactions}
    //       deleteTransaction={deleteRecurringTransaction}
    //       tabName="Loans"
    //     />
    //   ),
    // },
    {
      id: 4,
      name: "Credit Cards",
      component: (
        <AccountTransaction
          // transactions={transactions && transactions.creditData}
          transactions={filteredData && filteredData}
          clientTransactions={clientTransactions && clientTransactions}
          deleteTransaction={deleteRecurringTransaction}
          selectedRowsDataKeys={selectedRowsDataKeys}
          selectedRowKeys={selectedRowKeys}
          hideRecurringTransaction={hideRecurringTransaction}
          restoreRecurringTransaction={restoreRecurringTransaction}
          tabName="Credit Cards"
        />
      ),
    },
    {
      id: 5,
      name: "Hidden",
      component: (
        <AccountTransaction
          // transactions={transactions && transactions.creditData}
          transactions={filteredData && filteredData}
          clientTransactions={clientTransactions && clientTransactions}
          deleteTransaction={deleteRecurringTransaction}
          selectedRowsDataKeys={selectedRowsDataKeys}
          selectedRowKeys={selectedRowKeys}
          hideRecurringTransaction={hideRecurringTransaction}
          restoreRecurringTransaction={restoreRecurringTransaction}
          tabName="Hidden"
        />
      ),
    },
    // {
    //   id: 5,
    //   name: "Investments",
    //   component: (
    //     <AccountTransaction
    //       transactions={transactions && transactions.investmentData}
    //       clientTransactions={clientTransactions && clientTransactions}
    //       deleteTransaction={deleteRecurringTransaction}
    //       tabName="Investments"
    //     />
    //   ),
    // },
  ];

  return (
    <div className="addBudgetMain" style={{ position: "relative" }}>
      <div className="addbudgetSection">
        <div style={{ display: "flex", alignItems: "center", gap: "2rem" }}>
          <div className="addTitle">
            Recurring{" "}
            <span>
              <Dropdown
                trigger={["click"]}
                overlay={
                  <Menu>
                    <Menu.Item>
                      <div
                        onClick={() => {
                          history.push("/budget");
                        }}>
                        Dashboard
                      </div>
                    </Menu.Item>
                    <Menu.Item>
                      <div
                        onClick={() => {
                          history.push("/budget/add/transaction");
                        }}>
                        Transactions
                      </div>
                    </Menu.Item>
                    <Menu.Item>
                      <div
                        onClick={() => {
                          history.push("/budget/add/budget");
                        }}>
                        Budget
                      </div>
                    </Menu.Item>
                    <Menu.Item
                    //   style={{ cursor: "not-allowed", opacity: "0.7" }}
                    >
                      <div
                        onClick={() => {
                          history.push("/budget/transaction/recurring");
                        }}>
                        Recurring
                      </div>
                    </Menu.Item>
                  </Menu>
                }>
                <a
                  className="ant-dropdown-link"
                  onClick={(e) => e.preventDefault()}>
                  <img src={editIcon} height={12} width={18} alt="icon"></img>
                </a>
              </Dropdown>
            </span>
          </div>
          <div style={{ display: "flex", gap: "1rem", alignItems: "center" }}>
            {filter && filter && (
              <div className="savebutton" style={{ width: "fit-content" }}>
                By {filter}
                <span
                  className="custom-footer-text"
                  onClick={() => {
                    setFilter(null);
                    filteredTransactions();
                  }}>
                  <Icon
                    type="close-circle"
                    style={{
                      marginBottom: "3px",
                      marginLeft: "8px",
                      fontWeight: "800",
                      fontSize: "18px",
                    }}
                  />{" "}
                </span>
              </div>
            )}
          </div>
        </div>
        <div className="budgetcreate" style={{ gap: "1rem" }}>
          <div style={{ marginBottom: "0px" }}>
            <input
              style={{ marginBottom: "0px" }}
              className="searchStyle"
              placeholder="Search"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </div>
          <div className="filterIcons">
            <Dropdown
              trigger={["click"]}
              overlay={
                <Menu>
                  <div
                    style={{
                      fontWeight: "bolder",
                      paddingInline: "12px",
                      marginBottom: "8px",
                      marginTop: "8px",
                    }}>
                    Type
                  </div>
                  <Menu.Item>
                    <div
                      onClick={() => {
                        handleFilter("Account");
                      }}>
                      Account
                    </div>
                  </Menu.Item>
                  <Menu.Item>
                    <div
                      onClick={() => {
                        handleFilter("Amount");
                      }}>
                      Amount
                    </div>
                  </Menu.Item>
                  <Menu.Item>
                    <div
                      onClick={() => {
                        handleFilter("Due Date");
                      }}>
                      Due Date
                    </div>
                  </Menu.Item>
                  <Menu.Item>
                    <div
                      onClick={() => {
                        handleFilter("Alphabetical");
                      }}>
                      Alphabetical
                    </div>
                  </Menu.Item>
                </Menu>
              }>
              <a
                className="ant-dropdown-link"
                onClick={(e) => e.preventDefault()}>
                <img src={filterIcon} height={24} width={24} alt="icon"></img>
              </a>
            </Dropdown>
          </div>
          <img
          style={{ marginTop: "5px", cursor: "pointer" }}
          onClick={() => {
            history.push("/budget/transaction/recurring/rules")
          }}
          src={settingIcon}
          height={24}
          width={24}></img>
        </div>
      </div>
      <div className="TabSection">
        <Tab onTabSelected={onTabSelected}>
          {Tabs.map((tab, index) => (
            <TabItem key={tab.id}>{tab.name}</TabItem>
          ))}
        </Tab>
      </div>
      <div
        style={{
          width: "100%",
          display: "flex",
          alignItems: "end",
          justifyContent: "end",
          gap: "1rem",
        }}>
        {selectedRowKeys && selectedRowKeys.length > 0 && (
          <button
            className="savebutton"
            style={{ width: "fit-content" }}
            onClick={() => {
              if(selectedIndex===3){
                restoreSelectedTransaction()
              }
              else{
                hideSelectedTransaction();
              }
              // deleteSelectedTransaction();
            }}>
            {" "}
            Edit Multiple{" "}
          </button>
        )}
      </div>
      <div className="ComponentSection">{Tabs[selectedIndex].component}</div>

      <NewLoader isLoading={loading} />
      {/* <Loader isLoading={loading} /> */}
    </div>
  );
};
